/**
 * @copyright WaterStreet. All rights reserved.
 */

import {
	Component
} from '@angular/core';

@Component({
	selector: 'app-account',
	templateUrl: './account.component.html'
})

/**
 * A component representing an instance of the main
 * profile settings page.
 *
 * @export
 * @class AccountComponent
 */
export class AccountComponent
{
}